export default "__VITE_ASSET__AAI1Satv__"